import $ from 'jquery';
import slick from 'slick-slider'
import lazyLoad from './lazyLoad';
import respImg from './responsiveImages';

function is_touch_enabled() {
    return ('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0);
}

// var isTouch = is_touch_enabled();
var isTouch = true;
var isMobile = false;

function setIsMobile() {
    var newIsMobile = $(window).width() < 768;
    if (newIsMobile != isMobile) {
        $('.cover-screen').trigger('reset-cover-screen');
    }
    isMobile = newIsMobile;
}

function restartSlider(el) {
    el.find('.slick-slider').slick('slickPause');
    el.find('[data-timer] span').stop();
    if (!isMobile) {
        var active = el.find('.active .slick-slider');
        if (active.length) {
            var timer = el.find('.active [data-timer]');
            active.slick('slickPlay');
            animateTimer(timer);
            active.lazyLoad();
        }
    }
}

function animateTimer(timer) {
    timer.find('span').stop().css('width', '0%').animate({ width: '100%' }, 3000, 'linear');
}

function preloadNextImage(el) {
    var slider = el.find('section.active [data-cover-screen-slider]');
    var next = slider.find('.slick-slide.slick-current').next().lazyLoad();
}

function initCoverScreen(el) {

    el.find('[data-cover-screen-slider]').each(function () {
        $(this).on('beforeChange', function () {
            var timer = $(this).closest('section').find('[data-timer]');
            animateTimer(timer);
        });
        $(this).on('init', function () {
            respImg.initEl($(this), true);
            $(this).lazyLoad();
        });
        // $(this).on('afterChange',function() {
        //     console.log(el);
        //     preloadNextImage( el );
        // });
        $(this).slick({
            dots: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'linear',
            draggable: false,
            arrows: false,
            lazyLoad: false,
        });


    });

    if (!isTouch && !isMobile) {
        el.find('section').hover(function (e) {
            $(this).toggleClass('active', e.type == 'mouseenter');
            var i = $(this).index();
            var className = i ? "hover-right" : "hover-left";
            if (e.type == "mouseenter") {
                el.addClass('hover');
                el.addClass(className);

            } else {
                el.removeClass('hover');
                el.removeClass(className);
            }
            restartSlider(el);
        });
    } else {
        el.addClass('has-touch');
        el.find('section [data-close]').on('click', function (e) {
            var section = $(this).closest('section');
            if (!section.hasClass('active')) return;
            e.stopPropagation();
            el.removeClass('hover hover-left hover-right');
            section.removeClass('active').css('minHeight', '');
            restartSlider(el);
        });
        el.find('.cover-screen__separator a').on('click', function () {
            var i = $(this).index() ? 1 : 0;
            var section = el.find('section').eq(i);
            if (section.hasClass('active')) {
                el.removeClass('hover hover-left hover-right');
                section.removeClass('active').css('minHeight', '');
                restartSlider(el);
            } else {
                section.trigger('click');
            }
        });

        el.find('section').click(function (e) {
            if (e.isPropagationStopped()) {
                return;
            }
            if (!el.data('height')) {
                el.attr('data-height', el.outerHeight());
            }

            var section = $(this);
            $(this).addClass('active').siblings().removeClass('active').css('minHeight', '');
            preloadNextImage(el);
            var nav = section.find('nav');
            var minHeight = el.data('height') - 210 + 76;
            if (nav.outerHeight() > minHeight) minHeight = nav.outerHeight();
            section.css('minHeight', minHeight);
            var i = $(this).index();
            var className = i ? "hover-right" : "hover-left";
            el.removeClass('hover-right hover-left');
            el.addClass('hover');
            el.addClass(className);
            restartSlider(el);
        });
    }
    el.on('reset-cover-screen', function () {
        el.removeClass('hover hover-left hover-right');
        el.find('section').css('height', '').removeClass('active');
        el.attr('data-height', '');
        restartSlider(el);
    });

    var setVars = function () {
        var h = el.outerHeight();
        var w = el.outerWidth();
        var style = el.get(0).style;
        var vars = {
            vpadding: (h > 540) ? '25px' : '',
            edge: Math.round(h * 0.18) + 'px',
            mobileAngle: (Math.atan(70 / w) * 180 / Math.PI) + 'deg',
        };
        for (var n in vars) {
            style.setProperty(`--${n}`, vars[n]);
        }
    };
    $(window).on('resize', setVars);
    setVars();
}

export default {
    init: function () {
        setIsMobile();
        $(window).on('resize', setIsMobile);

        $('.cover-screen').each(function () {
            initCoverScreen($(this));
        });
    }
}
